import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalService } from './global/global.service';
import { Router } from '@angular/router';
import { UserStoreService } from './user/user-store.service';
import { UserRequestsService } from './user/user-requests.service';
import { StorageMap } from '@ngx-pwa/local-storage';
import { ModalIconComponent } from '../theme/components/modal-icon/modal-icon.component';
import { MatDialog } from '@angular/material/dialog';
import { RescueStoreService } from './rescue/rescue-store.service';
import { RescueRequestsService } from './rescue/rescue-requests.service';
import { DialogService } from './dialog/dialog.service';
import { TraspasoRequestsService } from './traspaso/traspaso-requests.service';
import { TransferRequestsService } from './transfer/transfer-requests.service';
import { ConfigurationRequestsService } from './configuration/configuration-requests.service';

@Injectable()
export class PrivateInterceptor implements HttpInterceptor {
  requests = 0;
  constructor(
    private globalService: GlobalService,
    private userStore: UserStoreService,
    private userRequests: UserRequestsService,
    private storageMap: StorageMap,
    private router: Router,
    private matDialog: MatDialog,
    public rescueRequestsService: RescueRequestsService,
    public traspasoRequestsService: TraspasoRequestsService,
    private dialogService: DialogService,
    public transferRequestsService: TransferRequestsService,
    public configurationRequestsService: ConfigurationRequestsService,
    ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/rescate/private/listarRescates`
      ) ||
      !req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/rescate`
      )
    ){
      this.rescueRequestsService.resetRescueData();
    }

    if (
      !req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/traspaso`
      )
    ){
      this.traspasoRequestsService.resetTraspasoData();
    }

    if (
      !req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/transferencias`
      )
    ){
      this.transferRequestsService.resetTransferenciaData();
    }

    if (
      !req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/configuracion`
      ) &&
      !req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/cliente`
      )
    ){
      this.configurationRequestsService.resetConfigurationData();
    }

    if (
      req.url.includes(
        `${this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'}/usuario/clave/validar`
      ) ||
      req.url.includes(
        `${this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'}/usuario/clave/grabar`
      ) ||
      req.url.includes(
        `${this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'}/usuario/clave/correo`
      ) 
    ) {
      const reqClone = req.clone({
        headers: this.fillHeaders(),
        params: new HttpParams().set('g-recaptcha-response', this.globalService.reCaptchaToken),
      });
      //
      return next.handle(reqClone).pipe(
        catchError((errorResponse: HttpErrorResponse) => {
          this.globalService.hideLoading();
          //
          if(errorResponse.url.includes('obtenerCucs')){
            this.router.navigate(['/login/mantenimiento']);    
          }
          else if(errorResponse.url.includes('generarToken')){
            this.router.navigate(['/login/mantenimiento']);    
          }
          else{
            this.router.navigate(['/oops']);            
          }
          return throwError(errorResponse);
        })
      );
    }

    if (
      req.url.includes(
        `${this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'}/cliente/private/obtenerCucs`
      ) ||
      req.url.includes(
        `${this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'}/cliente/private/obtenerAasesor`
      ) 
    ) {
      const reqClone = req.clone({
        headers: this.fillHeaders(),
        params: new HttpParams().set('g-recaptcha-response', this.globalService.reCaptchaToken),
      });
      //
      return next.handle(reqClone).pipe(
        catchError((errorResponse: HttpErrorResponse) => {
          this.globalService.hideLoading();
          //
          if(errorResponse.url.includes('obtenerCucs')){
            this.router.navigate(['/login/mantenimiento']);    
          }
          else if(errorResponse.url.includes('generarToken')){
            this.router.navigate(['/login/mantenimiento']);    
          }
          else{
            this.router.navigate(['/oops']);            
          }
          return throwError(errorResponse);
        })
      );
    }

    if (
      req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/dashboard`
      ) ||
      req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/consultas`
      ) ||
      req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/traspaso`
      ) ||
      req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/rescate`
      ) ||
        req.url.includes(
          `${
            this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/transfer`
      ) ||
      req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/eecc`
      )||
      req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/cliente`
      ) ||
      req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/constancia`
      )||
      req.url.includes(
        `${
          this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
        }/afiliacion`
      )||
      req.url.includes(
        this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiClientes : 'fondos-frontend'
      )
    ) {
      if (!this.requests) {
        this.globalService.showLoading();
      }
      //
      
//https://svomamozu5.execute-api.us-west-2.amazonaws.com/dev/api/fondos/cliente/private/perfil/calculoperfil/historico-perfil/perfil-vigente/PE/DNI00030982

      this.requests++;
      const reqClone = req.clone({
        headers: this.fillHeaders(),
      });
      //
      return next.handle(reqClone).pipe(
        tap((apiResponse) => {
          if (apiResponse instanceof HttpResponse) {
            this.requests--;
            if (this.requests === 0) {
              this.globalService.hideLoading();
            }

            if (
                (apiResponse.body && apiResponse.body.resultado && 
                (apiResponse.body.resultado.codigo == 2 || apiResponse.body.resultado.codigo == 3)) ||
                !apiResponse.body
              ) {
              this.resetAndRedirect(1);
            }


            /* if (
                (apiResponse.body  && (apiResponse.body.status == 500))
              ) {
              this.resetAndRedirect(1);
            }*/

            if(!req.url.includes(
              `${
                this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiFondos : 'fondos-frontend'
              }/rescate/private/enviarMail`
            )){
            }
            
          }
        }),
        catchError((errorResponse: HttpErrorResponse) => {
          console.log(errorResponse);
          this.globalService.hideLoading();
          this.requests = 0;
          if (errorResponse.status === 401) {
            this.resetAndRedirect(1);
          } else if (!req.url.includes('/private/rendimientosPortafolio') 
                    && !req.url.includes('/private/insertarLog') 
                  && !req.url.includes('/private/perfil/calculoperfil/historico-perfil')) 
          {
            this.resetAndRedirect();
          }else if(req.url.includes('/private/insertarLog')){
            console.error("continuar Proceso de logs")
          }else if(req.url.includes('/private/perfil/calculoperfil/historico-perfil')){
            console.error("continuar Proceso de perfil")
          }
          return throwError(errorResponse);
        })
      );
    }

      //https://svomamozu5.execute-api.us-west-2.amazonaws.com/dev/api/fondos/cliente/private/perfil/calculoperfil/historico-perfil/perfil-vigentes/PE/DNI000309821


    return next.handle(req);
  }

  fillHeaders() {
    return new HttpHeaders()
      .set('x-api-key', this.globalService.globalEnvironments.apiKey)
      .set(
        'Authorization',
        `Bearer ${typeof this.userStore.authToken == 'object' ? this.userStore.authToken['jwtToken'] : this.userStore.authToken}`
      );
  }

  resetAndRedirect(redirect?) {
    if (redirect) {
      this.storageMap.clear().subscribe(() => {
        this.userRequests.resetCognito().subscribe();
      });
    }
    this.router.navigate(['/oops']);
  }


  showModal(text){
    var options =  {
      icon: 'info',
      title: text,
      confirmbtn: 'Entendido',
    }

    this.dialogService.open(options);
    this.dialogService.confirmed().subscribe(confirmed => {})
  }


}